import type { CountryInfoInterface } from "@interfaces/CountryInfoInterface";

import ad from "../components/icons/flags/ad.svg";
import ae from "../components/icons/flags/ae.svg";
import af from "../components/icons/flags/af.svg";
import ag from "../components/icons/flags/ag.svg";
import ai from "../components/icons/flags/ai.svg";
import al from "../components/icons/flags/al.svg";
import am from "../components/icons/flags/am.svg";
import ao from "../components/icons/flags/ao.svg";
import ar from "../components/icons/flags/ar.svg";
import as from "../components/icons/flags/as.svg";
import at from "../components/icons/flags/at.svg";
import au from "../components/icons/flags/au.svg";
import aw from "../components/icons/flags/aw.svg";
import ax from "../components/icons/flags/ax.svg";
import az from "../components/icons/flags/az.svg";
import ba from "../components/icons/flags/ba.svg";
import bb from "../components/icons/flags/bb.svg";
import be from "../components/icons/flags/be.svg";
import bf from "../components/icons/flags/bf.svg";
import bg from "../components/icons/flags/bg.svg";
import bh from "../components/icons/flags/bh.svg";
import bi from "../components/icons/flags/bi.svg";
import bj from "../components/icons/flags/bj.svg";
import bl from "../components/icons/flags/bl.svg";
import bm from "../components/icons/flags/bm.svg";
import bn from "../components/icons/flags/bn.svg";
import bo from "../components/icons/flags/bo.svg";
import br from "../components/icons/flags/br.svg";
import bs from "../components/icons/flags/bs.svg";
import bt from "../components/icons/flags/bt.svg";
import bw from "../components/icons/flags/bw.svg";
import by from "../components/icons/flags/by.svg";
import bz from "../components/icons/flags/bz.svg";
import ca from "../components/icons/flags/ca.svg";
import cc from "../components/icons/flags/cc.svg";
import cd from "../components/icons/flags/cd.svg";
import cf from "../components/icons/flags/cf.svg";
import cg from "../components/icons/flags/cg.svg";
import ch from "../components/icons/flags/ch.svg";
import ci from "../components/icons/flags/ci.svg";
import ck from "../components/icons/flags/ck.svg";
import cl from "../components/icons/flags/cl.svg";
import cm from "../components/icons/flags/cm.svg";
import cn from "../components/icons/flags/cn.svg";
import co from "../components/icons/flags/co.svg";
import cr from "../components/icons/flags/cr.svg";
import cu from "../components/icons/flags/cu.svg";
import cv from "../components/icons/flags/cv.svg";
import cx from "../components/icons/flags/cx.svg";
import cy from "../components/icons/flags/cy.svg";
import cz from "../components/icons/flags/cz.svg";
import de from "../components/icons/flags/de.svg";
import dj from "../components/icons/flags/dj.svg";
import dk from "../components/icons/flags/dk.svg";
import dm from "../components/icons/flags/dm.svg";
import dom from "../components/icons/flags/do.svg";
import dz from "../components/icons/flags/dz.svg";
import ec from "../components/icons/flags/ec.svg";
import ee from "../components/icons/flags/ee.svg";
import eg from "../components/icons/flags/eg.svg";
import eh from "../components/icons/flags/eh.svg";
import er from "../components/icons/flags/er.svg";
import es from "../components/icons/flags/es.svg";
import et from "../components/icons/flags/et.svg";
import fi from "../components/icons/flags/fi.svg";
import fj from "../components/icons/flags/fj.svg";
import fk from "../components/icons/flags/fk.svg";
import fm from "../components/icons/flags/fm.svg";
import fo from "../components/icons/flags/fo.svg";
import fr from "../components/icons/flags/fr.svg";
import ga from "../components/icons/flags/ga.svg";
import gb from "../components/icons/flags/gb.svg";
import gd from "../components/icons/flags/gd.svg";
import ge from "../components/icons/flags/ge.svg";
import gf from "../components/icons/flags/gf.svg";
import gg from "../components/icons/flags/gg.svg";
import gh from "../components/icons/flags/gh.svg";
import gi from "../components/icons/flags/gi.svg";
import gl from "../components/icons/flags/gl.svg";
import gm from "../components/icons/flags/gm.svg";
import gn from "../components/icons/flags/gn.svg";
import gp from "../components/icons/flags/gp.svg";
import gq from "../components/icons/flags/gq.svg";
import gr from "../components/icons/flags/gr.svg";
import gs from "../components/icons/flags/gs.svg";
import gt from "../components/icons/flags/gt.svg";
import gu from "../components/icons/flags/gu.svg";
import gw from "../components/icons/flags/gw.svg";
import gy from "../components/icons/flags/gy.svg";
import hk from "../components/icons/flags/hk.svg";
import hn from "../components/icons/flags/hn.svg";
import hr from "../components/icons/flags/hr.svg";
import ht from "../components/icons/flags/ht.svg";
import hu from "../components/icons/flags/hu.svg";
import id from "../components/icons/flags/id.svg";
import ie from "../components/icons/flags/ie.svg";
import il from "../components/icons/flags/il.svg";
import im from "../components/icons/flags/im.svg";
import ind from "../components/icons/flags/in.svg";
import io from "../components/icons/flags/io.svg";
import iq from "../components/icons/flags/iq.svg";
import ir from "../components/icons/flags/ir.svg";
import is from "../components/icons/flags/is.svg";
import it from "../components/icons/flags/it.svg";
import je from "../components/icons/flags/je.svg";
import jm from "../components/icons/flags/jm.svg";
import jo from "../components/icons/flags/jo.svg";
import jp from "../components/icons/flags/jp.svg";
import ke from "../components/icons/flags/ke.svg";
import kg from "../components/icons/flags/kg.svg";
import kh from "../components/icons/flags/kh.svg";
import ki from "../components/icons/flags/ki.svg";
import km from "../components/icons/flags/km.svg";
import kn from "../components/icons/flags/kn.svg";
import kp from "../components/icons/flags/kp.svg";
import kr from "../components/icons/flags/kr.svg";
import kw from "../components/icons/flags/kw.svg";
import ky from "../components/icons/flags/ky.svg";
import kz from "../components/icons/flags/kz.svg";
import la from "../components/icons/flags/la.svg";
import lb from "../components/icons/flags/lb.svg";
import lc from "../components/icons/flags/lc.svg";
import li from "../components/icons/flags/li.svg";
import lk from "../components/icons/flags/lk.svg";
import lr from "../components/icons/flags/lr.svg";
import ls from "../components/icons/flags/ls.svg";
import lt from "../components/icons/flags/lt.svg";
import lu from "../components/icons/flags/lu.svg";
import lv from "../components/icons/flags/lv.svg";
import ly from "../components/icons/flags/ly.svg";
import ma from "../components/icons/flags/ma.svg";
import mc from "../components/icons/flags/mc.svg";
import md from "../components/icons/flags/md.svg";
import me from "../components/icons/flags/me.svg";
import mf from "../components/icons/flags/mf.svg";
import mg from "../components/icons/flags/mg.svg";
import mh from "../components/icons/flags/mh.svg";
import mk from "../components/icons/flags/mk.svg";
import ml from "../components/icons/flags/ml.svg";
import mm from "../components/icons/flags/mm.svg";
import mn from "../components/icons/flags/mn.svg";
import mo from "../components/icons/flags/mo.svg";
import mp from "../components/icons/flags/mp.svg";
import mq from "../components/icons/flags/mq.svg";
import mr from "../components/icons/flags/mr.svg";
import ms from "../components/icons/flags/ms.svg";
import mt from "../components/icons/flags/mt.svg";
import mu from "../components/icons/flags/mu.svg";
import mv from "../components/icons/flags/mv.svg";
import mw from "../components/icons/flags/mw.svg";
import mx from "../components/icons/flags/mx.svg";
import my from "../components/icons/flags/my.svg";
import mz from "../components/icons/flags/mz.svg";
import na from "../components/icons/flags/na.svg";
import nc from "../components/icons/flags/nc.svg";
import ne from "../components/icons/flags/ne.svg";
import nf from "../components/icons/flags/nf.svg";
import ng from "../components/icons/flags/ng.svg";
import ni from "../components/icons/flags/ni.svg";
import nl from "../components/icons/flags/nl.svg";
import no from "../components/icons/flags/no.svg";
import np from "../components/icons/flags/np.svg";
import nr from "../components/icons/flags/nr.svg";
import nu from "../components/icons/flags/nu.svg";
import nz from "../components/icons/flags/nz.svg";
import om from "../components/icons/flags/om.svg";
import pa from "../components/icons/flags/pa.svg";
import pe from "../components/icons/flags/pe.svg";
import pf from "../components/icons/flags/pf.svg";
import pg from "../components/icons/flags/pg.svg";
import ph from "../components/icons/flags/ph.svg";
import pk from "../components/icons/flags/pk.svg";
import pl from "../components/icons/flags/pl.svg";
import pm from "../components/icons/flags/pm.svg";
import pn from "../components/icons/flags/pn.svg";
import pr from "../components/icons/flags/pr.svg";
import ps from "../components/icons/flags/ps.svg";
import pt from "../components/icons/flags/pt.svg";
import pw from "../components/icons/flags/pw.svg";
import py from "../components/icons/flags/py.svg";
import qa from "../components/icons/flags/qa.svg";
import re from "../components/icons/flags/re.svg";
import ro from "../components/icons/flags/ro.svg";
import rs from "../components/icons/flags/rs.svg";
import ru from "../components/icons/flags/ru.svg";
import rw from "../components/icons/flags/rw.svg";
import sa from "../components/icons/flags/sa.svg";
import sb from "../components/icons/flags/sb.svg";
import sc from "../components/icons/flags/sc.svg";
import sd from "../components/icons/flags/sd.svg";
import se from "../components/icons/flags/se.svg";
import sg from "../components/icons/flags/sg.svg";
import sh from "../components/icons/flags/sh.svg";
import si from "../components/icons/flags/si.svg";
import sj from "../components/icons/flags/sj.svg";
import sk from "../components/icons/flags/sk.svg";
import sl from "../components/icons/flags/sl.svg";
import sm from "../components/icons/flags/sm.svg";
import sn from "../components/icons/flags/sn.svg";
import so from "../components/icons/flags/so.svg";
import sr from "../components/icons/flags/sr.svg";
import ss from "../components/icons/flags/ss.svg";
import st from "../components/icons/flags/st.svg";
import sv from "../components/icons/flags/sv.svg";
import sx from "../components/icons/flags/sx.svg";
import sy from "../components/icons/flags/sy.svg";
import sz from "../components/icons/flags/sz.svg";
import tc from "../components/icons/flags/tc.svg";
import td from "../components/icons/flags/td.svg";
import tg from "../components/icons/flags/tg.svg";
import th from "../components/icons/flags/th.svg";
import tj from "../components/icons/flags/tj.svg";
import tk from "../components/icons/flags/tk.svg";
import tl from "../components/icons/flags/tl.svg";
import tm from "../components/icons/flags/tm.svg";
import tn from "../components/icons/flags/tn.svg";
import to from "../components/icons/flags/to.svg";
import tr from "../components/icons/flags/tr.svg";
import tt from "../components/icons/flags/tt.svg";
import tv from "../components/icons/flags/tv.svg";
import tw from "../components/icons/flags/tw.svg";
import tz from "../components/icons/flags/tz.svg";
import ua from "../components/icons/flags/ua.svg";
import ug from "../components/icons/flags/ug.svg";
import us from "../components/icons/flags/us.svg";
import uy from "../components/icons/flags/uy.svg";
import uz from "../components/icons/flags/uz.svg";
import va from "../components/icons/flags/va.svg";
import vc from "../components/icons/flags/vc.svg";
import ve from "../components/icons/flags/ve.svg";
import vg from "../components/icons/flags/vg.svg";
import vi from "../components/icons/flags/vi.svg";
import vn from "../components/icons/flags/vn.svg";
import vu from "../components/icons/flags/vu.svg";
import wf from "../components/icons/flags/wf.svg";
import ws from "../components/icons/flags/ws.svg";
import xk from "../components/icons/flags/xk.svg";
import ye from "../components/icons/flags/ye.svg";
import yt from "../components/icons/flags/yt.svg";
import za from "../components/icons/flags/za.svg";
import zm from "../components/icons/flags/zm.svg";
import zw from "../components/icons/flags/zw.svg";

export const COUNTRIES: CountryInfoInterface[] = [
    {
        value: "Afghanistan",
        dialCode: "+93",
        language: {
            code: "ps",
            name: "Pashto",
        },
        code: "AF",
        imgSrc: af,
        currency: {
            code: "AFN",
            name: "Afghan afghani",
            symbol: "\u060b",
        },
        phoneLength: 12,
        sameDialCodeCount: 1,
    },
    {
        value: "\u00c5land Islands",
        dialCode: "+358",
        language: {
            code: "sv",
            name: "Swedish",
        },
        code: "AX",
        imgSrc: ax,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 12,
        sameDialCodeCount: 2,
    },
    {
        value: "Albania",
        dialCode: "+355",
        language: {
            code: "sq",
            name: "Albanian",
        },
        code: "AL",
        imgSrc: al,
        currency: {
            code: "ALL",
            name: "Albanian lek",
            symbol: "L",
        },
        phoneLength: 12,
        sameDialCodeCount: 1,
    },
    {
        value: "Algeria",
        dialCode: "+213",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "DZ",
        imgSrc: dz,
        currency: {
            code: "DZD",
            name: "Algerian dinar",
            symbol: "\u062f.\u062c",
        },
        phoneLength: 11,
        sameDialCodeCount: 1,
    },
    {
        value: "American Samoa",
        dialCode: "+1684",
        language: {
            code: "en",
            name: "English",
        },
        code: "AS",
        imgSrc: as,
        currency: {
            code: "USD",
            name: "United State Dollar",
            symbol: "$",
        },
        phoneLength: 11,
        sameDialCodeCount: 1,
    },
    {
        value: "Andorra",
        dialCode: "+376",
        language: {
            code: "ca",
            name: "Catalan",
        },
        code: "AD",
        imgSrc: ad,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 13,
        sameDialCodeCount: 1,
    },
    {
        value: "Angola",
        dialCode: "+244",
        language: {
            code: "pt",
            name: "Portuguese",
        },
        code: "AO",
        imgSrc: ao,
        currency: {
            code: "AOA",
            name: "Angolan kwanza",
            symbol: "Kz",
        },
        phoneLength: 14,
        sameDialCodeCount: 1,
    },
    {
        value: "Anguilla",
        dialCode: "+1264",
        language: {
            code: "en",
            name: "English",
        },
        code: "AI",
        imgSrc: ai,
        currency: {
            code: "XCD",
            name: "East Caribbean dollar",
            symbol: "$",
        },
        phoneLength: 11,
        sameDialCodeCount: 1,
    },
    {
        value: "Antigua and Barbuda",
        dialCode: "+1268",
        language: {
            code: "en",
            name: "English",
        },
        code: "AG",
        imgSrc: ag,
        currency: {
            code: "XCD",
            name: "East Caribbean dollar",
            symbol: "$",
        },
        phoneLength: 11,
        sameDialCodeCount: 1,
    },
    {
        value: "Argentina",
        dialCode: "+54",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "AR",
        imgSrc: ar,
        currency: {
            code: "ARS",
            name: "Argentine peso",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Armenia",
        dialCode: "+374",
        language: {
            code: "hy",
            name: "Armenian",
        },
        code: "AM",
        imgSrc: am,
        currency: {
            code: "AMD",
            name: "Armenian dram",
            symbol: "",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Aruba",
        dialCode: "+297",
        language: {
            code: "nl",
            name: "Dutch",
        },
        code: "AW",
        imgSrc: aw,
        currency: {
            code: "AWG",
            name: "Aruban florin",
            symbol: "\u0192",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Australia",
        dialCode: "+61",
        language: {
            code: "en",
            name: "English",
        },
        code: "AU",
        imgSrc: au,
        currency: {
            code: "AUD",
            name: "Australian dollar",
            symbol: "$",
        },
        phoneLength: 12,
        sameDialCodeCount: 3,
    },
    {
        value: "Austria",
        dialCode: "+43",
        language: {
            code: "de",
            name: "German",
        },
        code: "AT",
        imgSrc: at,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 12,
        sameDialCodeCount: 1,
    },
    {
        value: "Azerbaijan",
        dialCode: "+994",
        language: {
            code: "az",
            name: "Azerbaijani",
        },
        code: "AZ",
        imgSrc: az,
        currency: {
            code: "AZN",
            name: "Azerbaijani manat",
            symbol: "",
        },
        phoneLength: 13,
        sameDialCodeCount: 1,
    },
    {
        value: "Bahamas",
        dialCode: "+1242",
        language: {
            code: "en",
            name: "English",
        },
        code: "BS",
        imgSrc: bs,
        currency: {
            code: "BSD",
            name: "Bahamian dollar",
            symbol: "$",
        },
        phoneLength: 11,
        sameDialCodeCount: 1,
    },
    {
        value: "Bahrain",
        dialCode: "+973",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "BH",
        imgSrc: bh,
        currency: {
            code: "BHD",
            name: "Bahraini dinar",
            symbol: ".\u062f.\u0628",
        },
        phoneLength: 13,
        sameDialCodeCount: 1,
    },
    {
        value: "Bangladesh",
        dialCode: "+880",
        language: {
            code: "bn",
            name: "Bengali",
        },
        code: "BD",
        imgSrc: bg,
        currency: {
            code: "BDT",
            name: "Bangladeshi taka",
            symbol: "\u09f3",
        },
        phoneLength: 13,
        sameDialCodeCount: 1,
    },
    {
        value: "Barbados",
        dialCode: "+1246",
        language: {
            code: "en",
            name: "English",
        },
        code: "BB",
        imgSrc: bb,
        currency: {
            code: "BBD",
            name: "Barbadian dollar",
            symbol: "$",
        },
        phoneLength: 11,
        sameDialCodeCount: 1,
    },
    {
        value: "Belarus",
        dialCode: "+375",
        language: {
            code: "be",
            name: "Belarusian",
        },
        code: "BY",
        imgSrc: by,
        currency: {
            code: "BYN",
            name: "New Belarusian ruble",
            symbol: "Br",
        },
        phoneLength: 13,
        sameDialCodeCount: 1,
    },
    {
        value: "Belgium",
        dialCode: "+32",
        language: {
            code: "nl",
            name: "Dutch",
        },
        code: "BE",
        imgSrc: be,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 12,
        sameDialCodeCount: 1,
    },
    {
        value: "Belize",
        dialCode: "+501",
        language: {
            code: "en",
            name: "English",
        },
        code: "BZ",
        imgSrc: bz,
        currency: {
            code: "BZD",
            name: "Belize dollar",
            symbol: "$",
        },
        phoneLength: 10,
        sameDialCodeCount: 1,
    },
    {
        value: "Benin",
        dialCode: "+229",
        language: {
            code: "fr",
            name: "French",
        },
        code: "BJ",
        imgSrc: bj,
        currency: {
            code: "XOF",
            name: "West African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 13,
        sameDialCodeCount: 1,
    },
    {
        value: "Bermuda",
        dialCode: "+1441",
        language: {
            code: "en",
            name: "English",
        },
        code: "BM",
        imgSrc: bm,
        currency: {
            code: "BMD",
            name: "Bermudian dollar",
            symbol: "$",
        },
        phoneLength: 11,
        sameDialCodeCount: 1,
    },
    {
        value: "Bhutan",
        dialCode: "+975",
        language: {
            code: "dz",
            name: "Dzongkha",
        },
        code: "BT",
        imgSrc: bt,
        currency: {
            code: "BTN",
            name: "Bhutanese ngultrum",
            symbol: "Nu.",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Bolivia (Plurinational State of)",
        dialCode: "+591",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "BO",
        imgSrc: bo,
        currency: {
            code: "BOB",
            name: "Bolivian boliviano",
            symbol: "Bs.",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Bosnia and Herzegovina",
        dialCode: "+387",
        language: {
            code: "bs",
            name: "Bosnian",
        },
        code: "BA",
        imgSrc: ba,
        currency: {
            code: "BAM",
            name: "Bosnia and Herzegovina convertible mark",
            symbol: "",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Botswana",
        dialCode: "+267",
        language: {
            code: "en",
            name: "English",
        },
        code: "BW",
        imgSrc: bw,
        currency: {
            code: "BWP",
            name: "Botswana pula",
            symbol: "P",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Brazil",
        dialCode: "+55",
        language: {
            code: "pt",
            name: "Portuguese",
        },
        code: "BR",
        imgSrc: br,
        currency: {
            code: "BRL",
            name: "Brazilian real",
            symbol: "R$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "British Indian Ocean Territory",
        dialCode: "+246",
        language: {
            code: "en",
            name: "English",
        },
        code: "IO",
        imgSrc: io,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Brunei Darussalam",
        dialCode: "+673",
        language: {
            code: "ms",
            name: "Malay",
        },
        code: "BN",
        imgSrc: bn,
        currency: {
            code: "BND",
            name: "Brunei dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Bulgaria",
        dialCode: "+359",
        language: {
            code: "bg",
            name: "Bulgarian",
        },
        code: "BG",
        imgSrc: bg,
        currency: {
            code: "BGN",
            name: "Bulgarian lev",
            symbol: "\u043b\u0432",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Burkina Faso",
        dialCode: "+226",
        language: {
            code: "fr",
            name: "French",
        },
        code: "BF",
        imgSrc: bf,
        currency: {
            code: "XOF",
            name: "West African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Burundi",
        dialCode: "+257",
        language: {
            code: "fr",
            name: "French",
        },
        code: "BI",
        imgSrc: bi,
        currency: {
            code: "BIF",
            name: "Burundian franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Cambodia",
        dialCode: "+855",
        language: {
            code: "km",
            name: "Khmer",
        },
        code: "KH",
        imgSrc: kh,
        currency: {
            code: "KHR",
            name: "Cambodian riel",
            symbol: "\u17db",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Cameroon",
        dialCode: "+237",
        language: {
            code: "en",
            name: "English",
        },
        code: "CM",
        imgSrc: cm,
        currency: {
            code: "XAF",
            name: "Central African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Canada",
        dialCode: "+1",
        language: {
            code: "en",
            name: "English",
        },
        code: "CA",
        imgSrc: ca,
        currency: {
            code: "CAD",
            name: "Canadian dollar",
            symbol: "$",
        },
        phoneLength: 11,
        sameDialCodeCount: 2,
    },
    {
        value: "Cabo Verde",
        dialCode: "+238",
        language: {
            code: "pt",
            name: "Portuguese",
        },
        code: "CV",
        imgSrc: cv,
        currency: {
            code: "CVE",
            name: "Cape Verdean escudo",
            symbol: "Esc",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Cayman Islands",
        dialCode: "+345",
        language: {
            code: "en",
            name: "English",
        },
        code: "KY",
        imgSrc: ky,
        currency: {
            code: "KYD",
            name: "Cayman Islands dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Central African Republic",
        dialCode: "+236",
        language: {
            code: "fr",
            name: "French",
        },
        code: "CF",
        imgSrc: cf,
        currency: {
            code: "XAF",
            name: "Central African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Chad",
        dialCode: "+235",
        language: {
            code: "fr",
            name: "French",
        },
        code: "TD",
        imgSrc: td,
        currency: {
            code: "XAF",
            name: "Central African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Chile",
        dialCode: "+56",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "CL",
        imgSrc: cl,
        currency: {
            code: "CLP",
            name: "Chilean peso",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "China",
        dialCode: "+86",
        language: {
            code: "zh",
            name: "Chinese",
        },
        code: "CN",
        imgSrc: cn,
        currency: {
            code: "CNY",
            name: "Chinese yuan",
            symbol: "\u00a5",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Christmas Island",
        dialCode: "+61",
        language: {
            code: "en",
            name: "English",
        },
        code: "CX",
        imgSrc: cx,
        currency: {
            code: "AUD",
            name: "Australian dollar",
            symbol: "$",
        },
        phoneLength: 12,
        sameDialCodeCount: 3,
    },
    {
        value: "Cocos (Keeling) Islands",
        dialCode: "+61",
        language: {
            code: "en",
            name: "English",
        },
        code: "CC",
        imgSrc: cc,
        currency: {
            code: "AUD",
            name: "Australian dollar",
            symbol: "$",
        },
        phoneLength: 12,
        sameDialCodeCount: 3,
    },
    {
        value: "Colombia",
        dialCode: "+57",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "CO",
        imgSrc: co,
        currency: {
            code: "COP",
            name: "Colombian peso",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Comoros",
        dialCode: "+269",
        language: {
            code: "fr",
            name: "French",
        },
        code: "KM",
        imgSrc: km,
        currency: {
            code: "KMF",
            name: "Comorian franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Congo",
        dialCode: "+242",
        language: {
            code: "fr",
            name: "French",
        },
        code: "CG",
        imgSrc: cg,
        currency: {
            code: "XAF",
            name: "Central African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Congo (Democratic Republic of the)",
        dialCode: "+243",
        language: {
            code: "fr",
            name: "French",
        },
        code: "CD",
        imgSrc: cd,
        currency: {
            code: "CDF",
            name: "Congolese franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Cook Islands",
        dialCode: "+682",
        language: {
            code: "en",
            name: "English",
        },
        code: "CK",
        imgSrc: ck,
        currency: {
            code: "NZD",
            name: "New Zealand dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Costa Rica",
        dialCode: "+506",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "CR",
        imgSrc: cr,
        currency: {
            code: "CRC",
            name: "Costa Rican col\u00f3n",
            symbol: "\u20a1",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "C\u00f4te d'Ivoire",
        dialCode: "+225",
        language: {
            code: "fr",
            name: "French",
        },
        code: "CI",
        imgSrc: ci,
        currency: {
            code: "XOF",
            name: "West African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Croatia",
        dialCode: "+385",
        language: {
            code: "hr",
            name: "Croatian",
        },
        code: "HR",
        imgSrc: hr,
        currency: {
            code: "HRK",
            name: "Croatian kuna",
            symbol: "kn",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Cuba",
        dialCode: "+53",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "CU",
        imgSrc: cu,
        currency: {
            code: "CUC",
            name: "Cuban convertible peso",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Cyprus",
        dialCode: "+357",
        language: {
            code: "tr",
            name: "Turkish",
        },
        code: "CY",
        imgSrc: cy,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Czech Republic",
        dialCode: "+420",
        language: {
            code: "cs",
            name: "Czech",
        },
        code: "CZ",
        imgSrc: cz,
        currency: {
            code: "CZK",
            name: "Czech koruna",
            symbol: "K\u010d",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Denmark",
        dialCode: "+45",
        language: {
            code: "da",
            name: "Danish",
        },
        code: "DK",
        imgSrc: dk,
        currency: {
            code: "DKK",
            name: "Danish krone",
            symbol: "kr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Djibouti",
        dialCode: "+253",
        language: {
            code: "fr",
            name: "French",
        },
        code: "DJ",
        imgSrc: dj,
        currency: {
            code: "DJF",
            name: "Djiboutian franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Dominica",
        dialCode: "+1767",
        language: {
            code: "en",
            name: "English",
        },
        code: "DM",
        imgSrc: dm,
        currency: {
            code: "XCD",
            name: "East Caribbean dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Dominican Republic",
        dialCode: "+1",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "DO",
        imgSrc: dom,
        currency: {
            code: "DOP",
            name: "Dominican peso",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Ecuador",
        dialCode: "+593",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "EC",
        imgSrc: ec,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Egypt",
        dialCode: "+20",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "EG",
        imgSrc: eg,
        currency: {
            code: "EGP",
            name: "Egyptian pound",
            symbol: "\u00a3",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "El Salvador",
        dialCode: "+503",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "SV",
        imgSrc: sv,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Equatorial Guinea",
        dialCode: "+240",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "GQ",
        imgSrc: gq,
        currency: {
            code: "XAF",
            name: "Central African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Eritrea",
        dialCode: "+291",
        language: {
            code: "en",
            name: "English",
        },
        code: "ER",
        imgSrc: er,
        currency: {
            code: "ERN",
            name: "Eritrean nakfa",
            symbol: "Nfk",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Estonia",
        dialCode: "+372",
        language: {
            code: "et",
            name: "Estonian",
        },
        code: "EE",
        imgSrc: ee,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Ethiopia",
        dialCode: "+251",
        language: {
            code: "am",
            name: "Amharic",
        },
        code: "ET",
        imgSrc: et,
        currency: {
            code: "ETB",
            name: "Ethiopian birr",
            symbol: "Br",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Falkland Islands (Malvinas)",
        dialCode: "+500",
        language: {
            code: "en",
            name: "English",
        },
        code: "FK",
        imgSrc: fk,
        currency: {
            code: "FKP",
            name: "Falkland Islands pound",
            symbol: "\u00a3",
        },
        phoneLength: 8,
        sameDialCodeCount: 2,
    },
    {
        value: "Faroe Islands",
        dialCode: "+298",
        language: {
            code: "fo",
            name: "Faroese",
        },
        code: "FO",
        imgSrc: fo,
        currency: {
            code: "DKK",
            name: "Danish krone",
            symbol: "kr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Fiji",
        dialCode: "+679",
        language: {
            code: "en",
            name: "English",
        },
        code: "FJ",
        imgSrc: fj,
        currency: {
            code: "FJD",
            name: "Fijian dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Finland",
        dialCode: "+358",
        language: {
            code: "fi",
            name: "Finnish",
        },
        code: "FI",
        imgSrc: fi,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 12,
        sameDialCodeCount: 2,
    },
    {
        value: "France",
        dialCode: "+33",
        language: {
            code: "fr",
            name: "French",
        },
        code: "FR",
        imgSrc: fr,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "French Guiana",
        dialCode: "+594",
        language: {
            code: "fr",
            name: "French",
        },
        code: "GF",
        imgSrc: gf,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "French Polynesia",
        dialCode: "+689",
        language: {
            code: "fr",
            name: "French",
        },
        code: "PF",
        imgSrc: pf,
        currency: {
            code: "XPF",
            name: "CFP franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Gabon",
        dialCode: "+241",
        language: {
            code: "fr",
            name: "French",
        },
        code: "GA",
        imgSrc: ga,
        currency: {
            code: "XAF",
            name: "Central African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Gambia",
        dialCode: "+220",
        language: {
            code: "en",
            name: "English",
        },
        code: "GM",
        imgSrc: gm,
        currency: {
            code: "GMD",
            name: "Gambian dalasi",
            symbol: "D",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Georgia",
        dialCode: "+995",
        language: {
            code: "ka",
            name: "Georgian",
        },
        code: "GE",
        imgSrc: ge,
        currency: {
            code: "GEL",
            name: "Georgian Lari",
            symbol: "\u10da",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Germany",
        dialCode: "+49",
        language: {
            code: "de",
            name: "German",
        },
        code: "DE",
        imgSrc: de,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Ghana",
        dialCode: "+233",
        language: {
            code: "en",
            name: "English",
        },
        code: "GH",
        imgSrc: gh,
        currency: {
            code: "GHS",
            name: "Ghanaian cedi",
            symbol: "\u20b5",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Gibraltar",
        dialCode: "+350",
        language: {
            code: "en",
            name: "English",
        },
        code: "GI",
        imgSrc: gi,
        currency: {
            code: "GIP",
            name: "Gibraltar pound",
            symbol: "\u00a3",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Greece",
        dialCode: "+30",
        language: {
            code: "el",
            name: "Greek (modern)",
        },
        code: "GR",
        imgSrc: gr,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Greenland",
        dialCode: "+299",
        language: {
            code: "kl",
            name: "Kalaallisut",
        },
        code: "GL",
        imgSrc: gl,
        currency: {
            code: "DKK",
            name: "Danish krone",
            symbol: "kr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Grenada",
        dialCode: "+1473",
        language: {
            code: "en",
            name: "English",
        },
        code: "GD",
        imgSrc: gd,
        currency: {
            code: "XCD",
            name: "East Caribbean dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Guadeloupe",
        dialCode: "+590",
        language: {
            code: "fr",
            name: "French",
        },
        code: "GP",
        imgSrc: gp,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 13,
        sameDialCodeCount: 3,
    },
    {
        value: "Guam",
        dialCode: "+1671",
        language: {
            code: "en",
            name: "English",
        },
        code: "GU",
        imgSrc: gu,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Guatemala",
        dialCode: "+502",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "GT",
        imgSrc: gt,
        currency: {
            code: "GTQ",
            name: "Guatemalan quetzal",
            symbol: "Q",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Guernsey",
        dialCode: "+44",
        language: {
            code: "en",
            name: "English",
        },
        code: "GG",
        imgSrc: gg,
        currency: {
            code: "GBP",
            name: "British pound",
            symbol: "\u00a3",
        },
        phoneLength: 16,
        sameDialCodeCount: 4,
    },
    {
        value: "Guinea",
        dialCode: "+224",
        language: {
            code: "fr",
            name: "French",
        },
        code: "GN",
        imgSrc: gn,
        currency: {
            code: "GNF",
            name: "Guinean franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Guinea-Bissau",
        dialCode: "+245",
        language: {
            code: "pt",
            name: "Portuguese",
        },
        code: "GW",
        imgSrc: gw,
        currency: {
            code: "XOF",
            name: "West African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Guyana",
        dialCode: "+595",
        language: {
            code: "en",
            name: "English",
        },
        code: "GY",
        imgSrc: gy,
        currency: {
            code: "GYD",
            name: "Guyanese dollar",
            symbol: "$",
        },
        phoneLength: 10,
        sameDialCodeCount: 2,
    },
    {
        value: "Haiti",
        dialCode: "+509",
        language: {
            code: "fr",
            name: "French",
        },
        code: "HT",
        imgSrc: ht,
        currency: {
            code: "HTG",
            name: "Haitian gourde",
            symbol: "G",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Holy See",
        dialCode: "+379",
        language: {
            code: "fr",
            name: "French",
        },
        code: "VA",
        imgSrc: va,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Honduras",
        dialCode: "+504",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "HN",
        imgSrc: hn,
        currency: {
            code: "HNL",
            name: "Honduran lempira",
            symbol: "L",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Hong Kong",
        dialCode: "+852",
        language: {
            code: "en",
            name: "English",
        },
        code: "HK",
        imgSrc: hk,
        currency: {
            code: "HKD",
            name: "Hong Kong dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Hungary",
        dialCode: "+36",
        language: {
            code: "hu",
            name: "Hungarian",
        },
        code: "HU",
        imgSrc: hu,
        currency: {
            code: "HUF",
            name: "Hungarian forint",
            symbol: "Ft",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Iceland",
        dialCode: "+354",
        language: {
            code: "is",
            name: "Icelandic",
        },
        code: "IS",
        imgSrc: is,
        currency: {
            code: "ISK",
            name: "Icelandic kr\u00f3na",
            symbol: "kr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "India",
        dialCode: "+91",
        language: {
            code: "hi",
            name: "Hindi",
        },
        code: "IN",
        imgSrc: ind,
        currency: {
            code: "INR",
            name: "Indian rupee",
            symbol: "\u20b9",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Indonesia",
        dialCode: "+62",
        language: {
            code: "id",
            name: "Indonesian",
        },
        code: "ID",
        imgSrc: id,
        currency: {
            code: "IDR",
            name: "Indonesian rupiah",
            symbol: "Rp",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Iran (Islamic Republic of)",
        dialCode: "+98",
        language: {
            code: "fa",
            name: "Persian (Farsi)",
        },
        code: "IR",
        imgSrc: ir,
        currency: {
            code: "IRR",
            name: "Iranian rial",
            symbol: "\ufdfc",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Iraq",
        dialCode: "+964",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "IQ",
        imgSrc: iq,
        currency: {
            code: "IQD",
            name: "Iraqi dinar",
            symbol: "\u0639.\u062f",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Ireland",
        dialCode: "+353",
        language: {
            code: "ga",
            name: "Irish",
        },
        code: "IE",
        imgSrc: ie,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Isle of Man",
        dialCode: "+44",
        language: {
            code: "en",
            name: "English",
        },
        code: "IM",
        imgSrc: im,
        currency: {
            code: "GBP",
            name: "British pound",
            symbol: "\u00a3",
        },
        phoneLength: 16,
        sameDialCodeCount: 4,
    },
    {
        value: "Israel",
        dialCode: "+972",
        language: {
            code: "he",
            name: "Hebrew (modern)",
        },
        code: "IL",
        imgSrc: il,
        currency: {
            code: "ILS",
            name: "Israeli new shekel",
            symbol: "\u20aa",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Italy",
        dialCode: "+39",
        language: {
            code: "it",
            name: "Italian",
        },
        code: "IT",
        imgSrc: it,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Jamaica",
        dialCode: "+1876",
        language: {
            code: "en",
            name: "English",
        },
        code: "JM",
        imgSrc: jm,
        currency: {
            code: "JMD",
            name: "Jamaican dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Japan",
        dialCode: "+81",
        language: {
            code: "ja",
            name: "Japanese",
        },
        code: "JP",
        imgSrc: jp,
        currency: {
            code: "JPY",
            name: "Japanese yen",
            symbol: "\u00a5",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Jersey",
        dialCode: "+441534",
        language: {
            code: "en",
            name: "English",
        },
        code: "JE",
        imgSrc: je,
        currency: {
            code: "GBP",
            name: "British pound",
            symbol: "\u00a3",
        },
        phoneLength: 16,
        sameDialCodeCount: 1,
    },
    {
        value: "Jordan",
        dialCode: "+962",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "JO",
        imgSrc: jo,
        currency: {
            code: "JOD",
            name: "Jordanian dinar",
            symbol: "\u062f.\u0627",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Kazakhstan",
        dialCode: "+77",
        language: {
            code: "kk",
            name: "Kazakh",
        },
        code: "KZ",
        imgSrc: kz,
        currency: {
            code: "KZT",
            name: "Kazakhstani tenge",
            symbol: "",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Kenya",
        dialCode: "+254",
        language: {
            code: "en",
            name: "English",
        },
        code: "KE",
        imgSrc: ke,
        currency: {
            code: "KES",
            name: "Kenyan shilling",
            symbol: "Sh",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Kiribati",
        dialCode: "+686",
        language: {
            code: "en",
            name: "English",
        },
        code: "KI",
        imgSrc: ki,
        currency: {
            code: "AUD",
            name: "Australian dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Korea (Democratic People's Republic of)",
        dialCode: "+850",
        language: {
            code: "ko",
            name: "Korean",
        },
        code: "KP",
        imgSrc: kp,
        currency: {
            code: "KPW",
            name: "North Korean won",
            symbol: "\u20a9",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Korea (Republic of)",
        dialCode: "+82",
        language: {
            code: "ko",
            name: "Korean",
        },
        code: "KR",
        imgSrc: kr,
        currency: {
            code: "KRW",
            name: "South Korean won",
            symbol: "\u20a9",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Kuwait",
        dialCode: "+965",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "KW",
        imgSrc: kw,
        currency: {
            code: "KWD",
            name: "Kuwaiti dinar",
            symbol: "\u062f.\u0643",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Kyrgyzstan",
        dialCode: "+996",
        language: {
            code: "ky",
            name: "Kyrgyz",
        },
        code: "KG",
        imgSrc: kg,
        currency: {
            code: "KGS",
            name: "Kyrgyzstani som",
            symbol: "\u0441",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Lao People's Democratic Republic",
        dialCode: "+856",
        language: {
            code: "lo",
            name: "Lao",
        },
        code: "LA",
        imgSrc: la,
        currency: {
            code: "LAK",
            name: "Lao kip",
            symbol: "\u20ad",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Latvia",
        dialCode: "+371",
        language: {
            code: "lv",
            name: "Latvian",
        },
        code: "LV",
        imgSrc: lv,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Lebanon",
        dialCode: "+961",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "LB",
        imgSrc: lb,
        currency: {
            code: "LBP",
            name: "Lebanese pound",
            symbol: "\u0644.\u0644",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Lesotho",
        dialCode: "+266",
        language: {
            code: "en",
            name: "English",
        },
        code: "LS",
        imgSrc: ls,
        currency: {
            code: "LSL",
            name: "Lesotho loti",
            symbol: "L",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Liberia",
        dialCode: "+231",
        language: {
            code: "en",
            name: "English",
        },
        code: "LR",
        imgSrc: lr,
        currency: {
            code: "LRD",
            name: "Liberian dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Libya",
        dialCode: "+218",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "LY",
        imgSrc: ly,
        currency: {
            code: "LYD",
            name: "Libyan dinar",
            symbol: "\u0644.\u062f",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Liechtenstein",
        dialCode: "+423",
        language: {
            code: "de",
            name: "German",
        },
        code: "LI",
        imgSrc: li,
        currency: {
            code: "CHF",
            name: "Swiss franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Lithuania",
        dialCode: "+370",
        language: {
            code: "lt",
            name: "Lithuanian",
        },
        code: "LT",
        imgSrc: lt,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Luxembourg",
        dialCode: "+352",
        language: {
            code: "fr",
            name: "French",
        },
        code: "LU",
        imgSrc: lu,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Macao",
        dialCode: "+853",
        language: {
            code: "zh",
            name: "Chinese",
        },
        code: "MO",
        imgSrc: mo,
        currency: {
            code: "MOP",
            name: "Macanese pataca",
            symbol: "P",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Macedonia (the former Yugoslav Republic of)",
        dialCode: "+389",
        language: {
            code: "mk",
            name: "Macedonian",
        },
        code: "MK",
        imgSrc: mk,
        currency: {
            code: "MKD",
            name: "Macedonian denar",
            symbol: "\u0434\u0435\u043d",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Madagascar",
        dialCode: "+261",
        language: {
            code: "fr",
            name: "French",
        },
        code: "MG",
        imgSrc: mg,
        currency: {
            code: "MGA",
            name: "Malagasy ariary",
            symbol: "Ar",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Malawi",
        dialCode: "+265",
        language: {
            code: "en",
            name: "English",
        },
        code: "MW",
        imgSrc: mw,
        currency: {
            code: "MWK",
            name: "Malawian kwacha",
            symbol: "MK",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Malaysia",
        dialCode: "+60",
        language: {
            code: "",
            name: "Malaysian",
        },
        code: "MY",
        imgSrc: my,
        currency: {
            code: "MYR",
            name: "Malaysian ringgit",
            symbol: "RM",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Maldives",
        dialCode: "+960",
        language: {
            code: "dv",
            name: "Divehi",
        },
        code: "MV",
        imgSrc: mv,
        currency: {
            code: "MVR",
            name: "Maldivian rufiyaa",
            symbol: ".\u0783",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Mali",
        dialCode: "+223",
        language: {
            code: "fr",
            name: "French",
        },
        code: "ML",
        imgSrc: ml,
        currency: {
            code: "XOF",
            name: "West African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Malta",
        dialCode: "+356",
        language: {
            code: "mt",
            name: "Maltese",
        },
        code: "MT",
        imgSrc: mt,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Marshall Islands",
        dialCode: "+692",
        language: {
            code: "en",
            name: "English",
        },
        code: "MH",
        imgSrc: mh,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Martinique",
        dialCode: "+596",
        language: {
            code: "fr",
            name: "French",
        },
        code: "MQ",
        imgSrc: mq,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Mauritania",
        dialCode: "+222",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "MR",
        imgSrc: mr,
        currency: {
            code: "MRO",
            name: "Mauritanian ouguiya",
            symbol: "UM",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Mauritius",
        dialCode: "+230",
        language: {
            code: "en",
            name: "English",
        },
        code: "MU",
        imgSrc: mu,
        currency: {
            code: "MUR",
            name: "Mauritian rupee",
            symbol: "\u20a8",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Mayotte",
        dialCode: "+262",
        language: {
            code: "fr",
            name: "French",
        },
        code: "YT",
        imgSrc: yt,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 12,
        sameDialCodeCount: 2,
    },
    {
        value: "Mexico",
        dialCode: "+52",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "MX",
        imgSrc: mx,
        currency: {
            code: "MXN",
            name: "Mexican peso",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Micronesia (Federated States of)",
        dialCode: "+691",
        language: {
            code: "en",
            name: "English",
        },
        code: "FM",
        imgSrc: fm,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Moldova (Republic of)",
        dialCode: "+373",
        language: {
            code: "ro",
            name: "Romanian",
        },
        code: "MD",
        imgSrc: md,
        currency: {
            code: "MDL",
            name: "Moldovan leu",
            symbol: "L",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Monaco",
        dialCode: "+377",
        language: {
            code: "fr",
            name: "French",
        },
        code: "MC",
        imgSrc: mc,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Mongolia",
        dialCode: "+976",
        language: {
            code: "mn",
            name: "Mongolian",
        },
        code: "MN",
        imgSrc: mn,
        currency: {
            code: "MNT",
            name: "Mongolian t\u00f6gr\u00f6g",
            symbol: "\u20ae",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Montenegro",
        dialCode: "+382",
        language: {
            code: "sr",
            name: "Serbian",
        },
        code: "ME",
        imgSrc: me,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Montserrat",
        dialCode: "+1664",
        language: {
            code: "en",
            name: "English",
        },
        code: "MS",
        imgSrc: ms,
        currency: {
            code: "XCD",
            name: "East Caribbean dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Morocco",
        dialCode: "+212",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "MA",
        imgSrc: ma,
        currency: {
            code: "MAD",
            name: "Moroccan dirham",
            symbol: "\u062f.\u0645.",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Mozambique",
        dialCode: "+258",
        language: {
            code: "pt",
            name: "Portuguese",
        },
        code: "MZ",
        imgSrc: mz,
        currency: {
            code: "MZN",
            name: "Mozambican metical",
            symbol: "MT",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Myanmar",
        dialCode: "+95",
        language: {
            code: "my",
            name: "Burmese",
        },
        code: "MM",
        imgSrc: mm,
        currency: {
            code: "MMK",
            name: "Burmese kyat",
            symbol: "Ks",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Namibia",
        dialCode: "+264",
        language: {
            code: "en",
            name: "English",
        },
        code: "NA",
        imgSrc: na,
        currency: {
            code: "NAD",
            name: "Namibian dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Nauru",
        dialCode: "+674",
        language: {
            code: "en",
            name: "English",
        },
        code: "NR",
        imgSrc: nr,
        currency: {
            code: "AUD",
            name: "Australian dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Nepal",
        dialCode: "+977",
        language: {
            code: "ne",
            name: "Nepali",
        },
        code: "NP",
        imgSrc: np,
        currency: {
            code: "NPR",
            name: "Nepalese rupee",
            symbol: "\u20a8",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Netherlands",
        dialCode: "+31",
        language: {
            code: "nl",
            name: "Dutch",
        },
        code: "NL",
        imgSrc: nl,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "New Caledonia",
        dialCode: "+687",
        language: {
            code: "fr",
            name: "French",
        },
        code: "NC",
        imgSrc: nc,
        currency: {
            code: "XPF",
            name: "CFP franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "New Zealand",
        dialCode: "+64",
        language: {
            code: "en",
            name: "English",
        },
        code: "NZ",
        imgSrc: nz,
        currency: {
            code: "NZD",
            name: "New Zealand dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Nicaragua",
        dialCode: "+505",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "NI",
        imgSrc: ni,
        currency: {
            code: "NIO",
            name: "Nicaraguan c\u00f3rdoba",
            symbol: "C$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Niger",
        dialCode: "+227",
        language: {
            code: "fr",
            name: "French",
        },
        code: "NE",
        imgSrc: ne,
        currency: {
            code: "XOF",
            name: "West African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Nigeria",
        dialCode: "+234",
        language: {
            code: "en",
            name: "English",
        },
        code: "NG",
        imgSrc: ng,
        currency: {
            code: "NGN",
            name: "Nigerian naira",
            symbol: "\u20a6",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Niue",
        dialCode: "+683",
        language: {
            code: "en",
            name: "English",
        },
        code: "NU",
        imgSrc: nu,
        currency: {
            code: "NZD",
            name: "New Zealand dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Norfolk Island",
        dialCode: "+672",
        language: {
            code: "en",
            name: "English",
        },
        code: "NF",
        imgSrc: nf,
        currency: {
            code: "AUD",
            name: "Australian dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Northern Mariana Islands",
        dialCode: "+1670",
        language: {
            code: "en",
            name: "English",
        },
        code: "MP",
        imgSrc: mp,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Norway",
        dialCode: "+47",
        language: {
            code: "no",
            name: "Norwegian",
        },
        code: "NO",
        imgSrc: no,
        currency: {
            code: "NOK",
            name: "Norwegian krone",
            symbol: "kr",
        },
        phoneLength: 10,
        sameDialCodeCount: 2,
    },
    {
        value: "Oman",
        dialCode: "+968",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "OM",
        imgSrc: om,
        currency: {
            code: "OMR",
            name: "Omani rial",
            symbol: "\u0631.\u0639.",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Pakistan",
        dialCode: "+92",
        language: {
            code: "en",
            name: "English",
        },
        code: "PK",
        imgSrc: pk,
        currency: {
            code: "PKR",
            name: "Pakistani rupee",
            symbol: "\u20a8",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Palau",
        dialCode: "+680",
        language: {
            code: "en",
            name: "English",
        },
        code: "PW",
        imgSrc: pw,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Palestine, State of",
        dialCode: "+970",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "PS",
        imgSrc: ps,
        currency: {
            code: "ILS",
            name: "Israeli new sheqel",
            symbol: "\u20aa",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Panama",
        dialCode: "+507",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "PA",
        imgSrc: pa,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Papua New Guinea",
        dialCode: "+675",
        language: {
            code: "en",
            name: "English",
        },
        code: "PG",
        imgSrc: pg,
        currency: {
            code: "PGK",
            name: "Papua New Guinean kina",
            symbol: "K",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Paraguay",
        dialCode: "+595",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "PY",
        imgSrc: py,
        currency: {
            code: "PYG",
            name: "Paraguayan guaran\u00ed",
            symbol: "\u20b2",
        },
        phoneLength: 12,
        sameDialCodeCount: 2,
    },
    {
        value: "Peru",
        dialCode: "+51",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "PE",
        imgSrc: pe,
        currency: {
            code: "PEN",
            name: "Peruvian sol",
            symbol: "S/.",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Philippines",
        dialCode: "+63",
        language: {
            code: "en",
            name: "English",
        },
        code: "PH",
        imgSrc: ph,
        currency: {
            code: "PHP",
            name: "Philippine peso",
            symbol: "\u20b1",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Pitcairn",
        dialCode: "+872",
        language: {
            code: "en",
            name: "English",
        },
        code: "PN",
        imgSrc: pn,
        currency: {
            code: "NZD",
            name: "New Zealand dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Poland",
        dialCode: "+48",
        language: {
            code: "pl",
            name: "Polish",
        },
        code: "PL",
        imgSrc: pl,
        currency: {
            code: "PLN",
            name: "Polish z\u0142oty",
            symbol: "z\u0142",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Portugal",
        dialCode: "+351",
        language: {
            code: "pt",
            name: "Portuguese",
        },
        code: "PT",
        imgSrc: pt,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Puerto Rico",
        dialCode: "+1939",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "PR",
        imgSrc: pr,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Qatar",
        dialCode: "+974",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "QA",
        imgSrc: qa,
        currency: {
            code: "QAR",
            name: "Qatari riyal",
            symbol: "\u0631.\u0642",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Romania",
        dialCode: "+40",
        language: {
            code: "ro",
            name: "Romanian",
        },
        code: "RO",
        imgSrc: ro,
        currency: {
            code: "RON",
            name: "Romanian leu",
            symbol: "lei",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Russian Federation",
        dialCode: "+7",
        language: {
            code: "ru",
            name: "Russian",
        },
        code: "RU",
        imgSrc: ru,
        currency: {
            code: "RUB",
            name: "Russian ruble",
            symbol: "\u20bd",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Rwanda",
        dialCode: "+250",
        language: {
            code: "rw",
            name: "Kinyarwanda",
        },
        code: "RW",
        imgSrc: rw,
        currency: {
            code: "RWF",
            name: "Rwandan franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "R\u00e9union",
        dialCode: "+262",
        language: {
            code: "fr",
            name: "French",
        },
        code: "RE",
        imgSrc: re,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 12,
        sameDialCodeCount: 2,
    },
    {
        value: "Saint Barth\u00e9lemy",
        dialCode: "+590",
        language: {
            code: "fr",
            name: "French",
        },
        code: "BL",
        imgSrc: bl,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 13,
        sameDialCodeCount: 3,
    },
    {
        value: "Saint Helena, Ascension and Tristan da Cunha",
        dialCode: "+290",
        language: {
            code: "en",
            name: "English",
        },
        code: "SH",
        imgSrc: sh,
        currency: {
            code: "SHP",
            name: "Saint Helena pound",
            symbol: "\u00a3",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Saint Kitts and Nevis",
        dialCode: "+1869",
        language: {
            code: "en",
            name: "English",
        },
        code: "KN",
        imgSrc: kn,
        currency: {
            code: "XCD",
            name: "East Caribbean dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Saint Lucia",
        dialCode: "+1758",
        language: {
            code: "en",
            name: "English",
        },
        code: "LC",
        imgSrc: lc,
        currency: {
            code: "XCD",
            name: "East Caribbean dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Saint Martin (French part)",
        dialCode: "+590",
        language: {
            code: "en",
            name: "English",
        },
        code: "MF",
        imgSrc: mf,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 13,
        sameDialCodeCount: 3,
    },
    {
        value: "Saint Pierre and Miquelon",
        dialCode: "+508",
        language: {
            code: "fr",
            name: "French",
        },
        code: "PM",
        imgSrc: pm,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Saint Vincent and the Grenadines",
        dialCode: "+1784",
        language: {
            code: "en",
            name: "English",
        },
        code: "VC",
        imgSrc: vc,
        currency: {
            code: "XCD",
            name: "East Caribbean dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Samoa",
        dialCode: "+685",
        language: {
            code: "sm",
            name: "Samoan",
        },
        code: "WS",
        imgSrc: ws,
        currency: {
            code: "WST",
            name: "Samoan t\u0101l\u0101",
            symbol: "T",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "San Marino",
        dialCode: "+378",
        language: {
            code: "it",
            name: "Italian",
        },
        code: "SM",
        imgSrc: sm,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Sao Tome and Principe",
        dialCode: "+239",
        language: {
            code: "pt",
            name: "Portuguese",
        },
        code: "ST",
        imgSrc: st,
        currency: {
            code: "STD",
            name: "S\u00e3o Tom\u00e9 and Pr\u00edncipe dobra",
            symbol: "Db",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Saudi Arabia",
        dialCode: "+966",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "SA",
        imgSrc: sa,
        currency: {
            code: "SAR",
            name: "Saudi riyal",
            symbol: "\u0631.\u0633",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Senegal",
        dialCode: "+221",
        language: {
            code: "fr",
            name: "French",
        },
        code: "SN",
        imgSrc: sn,
        currency: {
            code: "XOF",
            name: "West African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Serbia",
        dialCode: "+381",
        language: {
            code: "sr",
            name: "Serbian",
        },
        code: "RS",
        imgSrc: rs,
        currency: {
            code: "RSD",
            name: "Serbian dinar",
            symbol: "\u0434\u0438\u043d.",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Seychelles",
        dialCode: "+248",
        language: {
            code: "fr",
            name: "French",
        },
        code: "SC",
        imgSrc: sc,
        currency: {
            code: "SCR",
            name: "Seychellois rupee",
            symbol: "\u20a8",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Sierra Leone",
        dialCode: "+232",
        language: {
            code: "en",
            name: "English",
        },
        code: "SL",
        imgSrc: sl,
        currency: {
            code: "SLL",
            name: "Sierra Leonean leone",
            symbol: "Le",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Singapore",
        dialCode: "+65",
        language: {
            code: "en",
            name: "English",
        },
        code: "SG",
        imgSrc: sg,
        currency: {
            code: "SGD",
            name: "Singapore dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Slovakia",
        dialCode: "+421",
        language: {
            code: "sk",
            name: "Slovak",
        },
        code: "SK",
        imgSrc: sk,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Slovenia",
        dialCode: "+386",
        language: {
            code: "sl",
            name: "Slovene",
        },
        code: "SI",
        imgSrc: si,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Solomon Islands",
        dialCode: "+677",
        language: {
            code: "en",
            name: "English",
        },
        code: "SB",
        imgSrc: sb,
        currency: {
            code: "SBD",
            name: "Solomon Islands dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Somalia",
        dialCode: "+252",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "SO",
        imgSrc: so,
        currency: {
            code: "SOS",
            name: "Somali shilling",
            symbol: "Sh",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "South Africa",
        dialCode: "+27",
        language: {
            code: "en",
            name: "English",
        },
        code: "ZA",
        imgSrc: za,
        currency: {
            code: "ZAR",
            name: "South African rand",
            symbol: "R",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "South Georgia and the South Sandwich Islands",
        dialCode: "+500",
        language: {
            code: "en",
            name: "English",
        },
        code: "GS",
        imgSrc: gs,
        currency: {
            code: "GBP",
            name: "British pound",
            symbol: "\u00a3",
        },
        phoneLength: 12,
        sameDialCodeCount: 2,
    },
    {
        value: "Spain",
        dialCode: "+34",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "ES",
        imgSrc: es,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Sri Lanka",
        dialCode: "+94",
        language: {
            code: "si",
            name: "Sinhalese",
        },
        code: "LK",
        imgSrc: lk,
        currency: {
            code: "LKR",
            name: "Sri Lankan rupee",
            symbol: "Rs",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Sudan",
        dialCode: "+249",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "SD",
        imgSrc: sd,
        currency: {
            code: "SDG",
            name: "Sudanese pound",
            symbol: "\u062c.\u0633.",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Suriname",
        dialCode: "+597",
        language: {
            code: "nl",
            name: "Dutch",
        },
        code: "SR",
        imgSrc: sr,
        currency: {
            code: "SRD",
            name: "Surinamese dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Svalbard and Jan Mayen",
        dialCode: "+47",
        language: {
            code: "no",
            name: "Norwegian",
        },
        code: "SJ",
        imgSrc: sj,
        currency: {
            code: "NOK",
            name: "Norwegian krone",
            symbol: "kr",
        },
        phoneLength: 12,
        sameDialCodeCount: 2,
    },
    {
        value: "Swaziland",
        dialCode: "+268",
        language: {
            code: "en",
            name: "English",
        },
        code: "SZ",
        imgSrc: sz,
        currency: {
            code: "SZL",
            name: "Swazi lilangeni",
            symbol: "L",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Sweden",
        dialCode: "+46",
        language: {
            code: "sv",
            name: "Swedish",
        },
        code: "SE",
        imgSrc: se,
        currency: {
            code: "SEK",
            name: "Swedish krona",
            symbol: "kr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Switzerland",
        dialCode: "+41",
        language: {
            code: "de",
            name: "German",
        },
        code: "CH",
        imgSrc: ch,
        currency: {
            code: "CHF",
            name: "Swiss franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Syrian Arab Republic",
        dialCode: "+963",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "SY",
        imgSrc: sy,
        currency: {
            code: "SYP",
            name: "Syrian pound",
            symbol: "\u00a3",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Taiwan",
        dialCode: "+886",
        language: {
            code: "zh",
            name: "Chinese",
        },
        code: "TW",
        imgSrc: tw,
        currency: {
            code: "TWD",
            name: "New Taiwan dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Tajikistan",
        dialCode: "+992",
        language: {
            code: "tg",
            name: "Tajik",
        },
        code: "TJ",
        imgSrc: tj,
        currency: {
            code: "TJS",
            name: "Tajikistani somoni",
            symbol: "\u0405\u041c",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Tanzania, United Republic of",
        dialCode: "+255",
        language: {
            code: "en",
            name: "English",
        },
        code: "TZ",
        imgSrc: tz,
        currency: {
            code: "TZS",
            name: "Tanzanian shilling",
            symbol: "Sh",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Thailand",
        dialCode: "+66",
        language: {
            code: "th",
            name: "Thai",
        },
        code: "TH",
        imgSrc: th,
        currency: {
            code: "THB",
            name: "Thai baht",
            symbol: "\u0e3f",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Timor-Leste",
        dialCode: "+670",
        language: {
            code: "pt",
            name: "Portuguese",
        },
        code: "TL",
        imgSrc: tl,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Togo",
        dialCode: "+228",
        language: {
            code: "fr",
            name: "French",
        },
        code: "TG",
        imgSrc: tg,
        currency: {
            code: "XOF",
            name: "West African CFA franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Tokelau",
        dialCode: "+690",
        language: {
            code: "en",
            name: "English",
        },
        code: "TK",
        imgSrc: tk,
        currency: {
            code: "NZD",
            name: "New Zealand dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Tonga",
        dialCode: "+676",
        language: {
            code: "en",
            name: "English",
        },
        code: "TO",
        imgSrc: to,
        currency: {
            code: "TOP",
            name: "Tongan pa\u02bbanga",
            symbol: "T$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Trinidad and Tobago",
        dialCode: "+1868",
        language: {
            code: "en",
            name: "English",
        },
        code: "TT",
        imgSrc: tt,
        currency: {
            code: "TTD",
            name: "Trinidad and Tobago dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Tunisia",
        dialCode: "+216",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "TN",
        imgSrc: tn,
        currency: {
            code: "TND",
            name: "Tunisian dinar",
            symbol: "\u062f.\u062a",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Turkey",
        dialCode: "+90",
        language: {
            code: "tr",
            name: "Turkish",
        },
        code: "TR",
        imgSrc: tr,
        currency: {
            code: "TRY",
            name: "Turkish lira",
            symbol: "",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Turkmenistan",
        dialCode: "+993",
        language: {
            code: "tk",
            name: "Turkmen",
        },
        code: "TM",
        imgSrc: tm,
        currency: {
            code: "TMT",
            name: "Turkmenistan manat",
            symbol: "m",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Turks and Caicos Islands",
        dialCode: "+1649",
        language: {
            code: "en",
            name: "English",
        },
        code: "TC",
        imgSrc: tc,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Tuvalu",
        dialCode: "+688",
        language: {
            code: "en",
            name: "English",
        },
        code: "TV",
        imgSrc: tv,
        currency: {
            code: "AUD",
            name: "Australian dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Uganda",
        dialCode: "+256",
        language: {
            code: "en",
            name: "English",
        },
        code: "UG",
        imgSrc: ug,
        currency: {
            code: "UGX",
            name: "Ugandan shilling",
            symbol: "Sh",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Ukraine",
        dialCode: "+380",
        language: {
            code: "uk",
            name: "Ukrainian",
        },
        code: "UA",
        imgSrc: ua,
        currency: {
            code: "UAH",
            name: "Ukrainian hryvnia",
            symbol: "\u20b4",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "United Arab Emirates",
        dialCode: "+971",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "AE",
        imgSrc: ae,
        currency: {
            code: "AED",
            name: "United Arab Emirates dirham",
            symbol: "\u062f.\u0625",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "United Kingdom of Great Britain and Northern Ireland",
        dialCode: "+44",
        language: {
            code: "en",
            name: "English",
        },
        code: "GB",
        imgSrc: gb,
        currency: {
            code: "GBP",
            name: "British pound",
            symbol: "\u00a3",
        },
        phoneLength: 12,
        sameDialCodeCount: 4,
    },
    {
        value: "United States of America",
        dialCode: "+1",
        language: {
            code: "en",
            name: "English",
        },
        code: "US",
        imgSrc: us,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 11,
        sameDialCodeCount: 2,
    },
    {
        value: "Uruguay",
        dialCode: "+598",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "UY",
        imgSrc: uy,
        currency: {
            code: "UYU",
            name: "Uruguayan peso",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Uzbekistan",
        dialCode: "+998",
        language: {
            code: "uz",
            name: "Uzbek",
        },
        code: "UZ",
        imgSrc: uz,
        currency: {
            code: "UZS",
            name: "Uzbekistani so'm",
            symbol: "",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Vanuatu",
        dialCode: "+678",
        language: {
            code: "en",
            name: "English",
        },
        code: "VU",
        imgSrc: vu,
        currency: {
            code: "VUV",
            name: "Vanuatu vatu",
            symbol: "Vt",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Venezuela (Bolivarian Republic of)",
        dialCode: "+58",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "VE",
        imgSrc: ve,
        currency: {
            code: "VEF",
            name: "Venezuelan bol\u00edvar",
            symbol: "Bs F",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Viet Nam",
        dialCode: "+84",
        language: {
            code: "vi",
            name: "Vietnamese",
        },
        code: "VN",
        imgSrc: vn,
        currency: {
            code: "VND",
            name: "Vietnamese \u0111\u1ed3ng",
            symbol: "\u20ab",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Virgin Islands (British)",
        dialCode: "+1284",
        language: {
            code: "en",
            name: "English",
        },
        code: "VG",
        imgSrc: vg,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Virgin Islands (U.S.)",
        dialCode: "+1340",
        language: {
            code: "en",
            name: "English",
        },
        code: "VI",
        imgSrc: vi,
        currency: {
            code: "USD",
            name: "United States dollar",
            symbol: "$",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Wallis and Futuna",
        dialCode: "+681",
        language: {
            code: "fr",
            name: "French",
        },
        code: "WF",
        imgSrc: wf,
        currency: {
            code: "XPF",
            name: "CFP franc",
            symbol: "Fr",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Yemen",
        dialCode: "+967",
        language: {
            code: "ar",
            name: "Arabic",
        },
        code: "YE",
        imgSrc: ye,
        currency: {
            code: "YER",
            name: "Yemeni rial",
            symbol: "\ufdfc",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Zambia",
        dialCode: "+260",
        language: {
            code: "en",
            name: "English",
        },
        code: "ZM",
        imgSrc: zm,
        currency: {
            code: "ZMW",
            name: "Zambian kwacha",
            symbol: "ZK",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Zimbabwe",
        dialCode: "+263",
        language: {
            code: "en",
            name: "English",
        },
        code: "ZW",
        imgSrc: zw,
        currency: {
            code: "BWP",
            name: "Botswana pula",
            symbol: "P",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Republic of Kosovo",
        dialCode: "+383",
        language: {
            code: "sq",
            name: "Albanian",
        },
        code: "XK",
        imgSrc: xk,
        currency: {
            code: "EUR",
            name: "Euro",
            symbol: "\u20ac",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Sint Maarten (Dutch part)",
        dialCode: "+1721",
        language: {
            code: "nl",
            name: "Dutch",
        },
        code: "SX",
        imgSrc: sx,
        currency: {
            code: "ANG",
            name: "Netherlands Antillean guilder",
            symbol: "\u0192",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "South Sudan",
        dialCode: "+211",
        language: {
            code: "en",
            name: "English",
        },
        code: "SS",
        imgSrc: ss,
        currency: {
            code: "SSP",
            name: "South Sudanese pound",
            symbol: "\u00a3",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
    {
        value: "Western Sahara",
        dialCode: "+732",
        language: {
            code: "es",
            name: "Spanish",
        },
        code: "EH",
        imgSrc: eh,
        currency: {
            code: "MAD",
            name: "Moroccan dirham",
            symbol: "\u062f.\u0645.",
        },
        phoneLength: 0,
        sameDialCodeCount: 1,
    },
];
